// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button, Label, Input } from "@revvsales/components";

// Components Imports

class GoogleSheetConfirmationBox extends Component {
  state = {
    confirm: false,
  };

  _toggleCheckbox = () => {
    this.setState(prevState => ({ confirm: !prevState.confirm }));
  };

  _onClose = () => {
    this.setState({ confirm: false });
    this.props.closePopup();
  };

  _onConfirmation = () => {
    const { confirmAction, closePopup } = this.props;
    confirmAction(this.state.confirm);
    closePopup();
  };

  render() {
    const {
      show,
      header,
      subHeader,
      checkboxLabel,
      cancelBtnText,
      okBtnText,
      name,
    } = this.props;
    return (
      <Modal
        open={show}
        onClose={this._onClose}
        closeOnOverlayClick={false}
        center>
        <div
          className="confirmation-popup"
          data-test="confirmationbox-confirmation-popup">
          <div
            className="quotedelete-title"
            data-test="confirmationbox-template-delete-title">
            {header}
          </div>
          <div
            className="quotedelete-description"
            data-test="confirmationbox-template-delete-description">
            {subHeader}
          </div>
          <div
            className="quotedelete-checkbox"
            data-test="confirmationbox-template-delete-checkbox">
            <Input
              id="documentdelete-checkbox"
              data-test="confirmationbox-template-delete-checkbox-input"
              type="checkbox"
              value=""
              checked={this.state.confirm}
              onChange={() => this._toggleCheckbox()}
            />
            <Label
              htmlFor="documentdelete-checkbox"
              data-test="documentdelete-checkbox-label">
              <span
                className="delete-checkbox-label"
                data-test="confirmationbox-template-delete-checkbox-label">
                {checkboxLabel}
              </span>
            </Label>
          </div>

          <div className="quote-footer">
            <div className="quote-popup-response">
              <Button
                className="btn btn-transparent createquotepopup-footer-cancelbtn"
                data-test="confirmationbox-no-i-do-not-want-template-delete-cancel-button"
                id={`${name}-confirm-cancel-btn`}
                onClick={this._onClose}>
                {cancelBtnText || "No, I do not want to"}
              </Button>
              <Button
                className="btn reject-document"
                data-test="confirmationbox-template-delete-button"
                id={`${name}-confirm-ok-btn`}
                onClick={this._onConfirmation}>
                {okBtnText || "Confirm"}
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default GoogleSheetConfirmationBox;



// WEBPACK FOOTER //
// ./src/components/GoogleCatalog/GoogleSheetConfirmationPopup.js